import { useState } from 'react'

const GUIDES = [
  { title: 'Getting started with AIRA', desc: 'Learn the basics', prompts: ['What can you help me with?', 'How do I write better prompts?', 'Show me what you can do'] },
  { title: "AIRA's Vision Capabilities", desc: 'Analyse images and documents', videoUrl: 'https://scribehow.com/embed/Use_the_AIRAs_Vision_Capabilities__RlQ16CfISR66QHAAOWC4EA?skipIntro=true&as=video' },
  { title: "AIRA's Web Search Capabilities", desc: 'Search the web in real time', videoUrl: 'https://scribehow.com/embed/AIRAs_Web_Search_Capabilities__iHa64Bk8Qdq8KJZY-qj2uA?skipIntro=true&as=video' },
  { title: 'Writing & communication', desc: 'Emails, documents, professional writing', prompts: ['Help me write a professional email', 'Summarise this text in simple terms', 'Improve the tone of this message'] },
  { title: 'Research & analysis', desc: 'Analyse information and extract insights', prompts: ['Analyse this data and find trends', 'What are the key takeaways?', 'Compare these two options for me'] },
  { title: 'Planning & productivity', desc: 'Organise your work and plan effectively', prompts: ['Help me plan my week', 'Break this project into tasks', 'What should I prioritise today?'] },
  { title: 'Pro tips', desc: 'Advanced techniques for best results', tips: ['Be specific with context and desired output', 'Break complex tasks into smaller steps', 'Use follow-up questions to refine responses'] },
]

interface GuidesViewProps {
  onTryPrompt: (p: string) => void
}

export function GuidesView({ onTryPrompt }: GuidesViewProps) {
  const [open, setOpen] = useState<number | null>(0)

  return (
    <>
      <div className="guides-view">
        <div className="guides-section-title">How to use AIRA</div>
        <div className="guides-section-sub">Learn how to get the most out of your AI assistant</div>
        {GUIDES.map((g, i) => (
          <div key={i} className="guide-accordion">
            <button className="guide-acc-head" onClick={() => setOpen(open === i ? null : i)}>
              <svg className={`guide-chevron${open === i ? ' open' : ''}`} viewBox="0 0 16 16" fill="none">
                <path d="M5 6l3 3 3-3" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
              </svg>
              <div>
                <div className="guide-acc-title">{g.title}</div>
                <div className="guide-acc-desc">{g.desc}</div>
              </div>
            </button>
            {open === i && (
              <div className="guide-acc-body open">
                {'videoUrl' in g && g.videoUrl ? (
                  <iframe className="guide-video" src={g.videoUrl} allowFullScreen title={g.title} />
                ) : 'tips' in g && g.tips ? (
                  g.tips!.map((t, j) => (
                    <div key={j} style={{ fontSize: 13, color: 'var(--text-secondary)', padding: '6px 0', display: 'flex', gap: 8 }}>
                      <span style={{ color: 'var(--accent)' }}>•</span>{t}
                    </div>
                  ))
                ) : 'prompts' in g && g.prompts ? (
                  g.prompts.map((p, j) => (
                    <button key={j} className="guide-prompt-btn" onClick={() => onTryPrompt(p)}>
                      {p}<span className="guide-prompt-try">Try this →</span>
                    </button>
                  ))
                ) : null}
              </div>
            )}
          </div>
        ))}
        <div className="guides-help-foot">
          Need more help? Ask AIRA directly — just type your question in the chat.
        </div>
      </div>
    </>
  )
}
